import { Component, OnInit, effect, inject, input } from '@angular/core';

import { AnchorDirective, CurrencyPipe, DynamicHtmlDirective, NavigationService } from '@frontend/vanilla/core';
import { TranslateModule } from '@ngx-translate/core';

import { QDType } from '../../../../config/appConstants';
import { UrlConstants } from '../../../../config/urlConstants';
import { MessageType } from '../../../../model/message.model';
import { QdInstrument } from '../../../../model/qdInstrument.model';
import { DataService } from '../../../../service/data.service';
import { DepositService } from '../../../../service/deposit.service';
import { GtmService } from '../../../../service/gtm.service';
import { OptionListService } from '../../../../service/optionList.service';
import { StoreService } from '../../../../service/store.service';
import { UserDataService } from '../../../../service/userDataService';
import { MessageComponent } from '../messages/message-component';

@Component({
    selector: 'app-additional-messages',
    templateUrl: 'additional-messages.component.html',
    styleUrls: ['./additional-messages.component.scss'],
    imports: [MessageComponent, TranslateModule, CurrencyPipe, AnchorDirective, DynamicHtmlDirective],
})
export class AdditionalMessagesComponent implements OnInit {
    private store = inject(StoreService);
    private optionListService = inject(OptionListService);
    private dataService = inject(DataService);
    private gtmService = inject(GtmService);
    private navigationService = inject(NavigationService);

    configParams: any;
    currencyPLN: string = 'PLN';
    selectedOption = input.required<QdInstrument>();
    arcDepositBlockStatus: any;
    arcDeclinedDepositClickHereUrl: string;
    type: MessageType;
    isEsRiskPlayer: boolean;
    liveChatRiskPlayerUrl: string;
    tempObj: { [k: string]: any } = {};
    sessionTimeout = {
        status: false,
        url: '',
    };
    reversal: any = {
        isExists: false,
        data: [],
        totalAmount: 0,
    };
    kycPLverification: boolean;
    kycRedirectionUrl: string;

    messageType = MessageType;
    errorCode = this.store.getErrorCode();
    constructor(
        private userDataService: UserDataService,
        public depositService: DepositService,
    ) {
        effect(() => {
            this.arcDepositBlockStatus = this.store.getArcDepositBlockStatus();
        });
    }

    ngOnInit() {
        this.configParams = this.userDataService?.userData?.configParams;
        const lang = this.dataService.sessionInfo?.LANG_ID;
        this.liveChatRiskPlayerUrl = `${this.userDataService?.userData?.configParams?.merchant_hostname}/${lang}${UrlConstants.LIVE_CHAT_ES_LINK}`;
        this.isEsRiskPlayer = this.selectedOption()?.paymentAccountInfo?.isESRiskPlayer == 'Y';
        if (this.isEsRiskPlayer) {
            this.gtmService.riskyPlayerAccountTempBlock('betslip quick deposit');
        }

        this.checkArchDeposit();

        this.sessionTimeout.status = !!this.userDataService?.userData?.userInfo?.sessionTimeOutStatus;
        if (this.sessionTimeout.status) {
            this.sessionTimeout.url = this.userDataService?.userData?.configParams?.session_limit_update_url || '';
        }

        this.getReversals();

        this.handlekycRedirection();
    }

    getReversals() {
        this.reversal.data = this.optionListService?.reversalArr || [];
        this.reversal.isExists = this.optionListService?.reversalExists;
        this.getSumOfAllReversals();
    }

    checkArchDeposit() {
        if (this.userDataService?.userData?.userInfo) {
            this.arcDepositBlockStatus = this.userDataService?.userData?.userInfo?.userARCDeclinedDepositStatus;
            this.arcDeclinedDepositClickHereUrl = this.userDataService?.userData?.configParams?.arcDeclinedDepositClickHereUrl || '';
            if (this.arcDepositBlockStatus?.depositBlocked) {
                this.handleArcDepositGtmEvent();
                this.optionListService.redirectToMainCashier();
            }
        }
    }

    handlekycRedirection() {
        this.kycPLverification = ['SUSPENDED_GRACE_DAYS_OVER', 'SUSPENDED_DEPOSIT_AMOUNT_EXCEEDED'].includes(
            this.userDataService?.userData?.userInfo?.ezecashCategoryComment,
        );
        this.kycRedirectionUrl = this.userDataService?.userData?.configParams?.kyc_verify_redirection_url || '';
        if (this.kycPLverification || this.sessionTimeout.status || this.errorCode()) {
            this.depositService.resizeCashier();
        }
    }

    liveChatUrlRisky() {
        this.gtmService.riskyPlayerClickOnLiveChat('account restricted message', 'betslip quick deposit', this.liveChatRiskPlayerUrl);
        this.navigationService.goTo(this.liveChatRiskPlayerUrl, { forceReloadTarget: 'top' });
    }
    submitAdaDeposit() {
        this.depositService.showDepositFailure.set(false);
        this.depositService.resizeCashier();
        this.store.setAdaInteractionMessage(false);
        this.store.errorCode.set(0);
        this.depositService.depositInfo.details.adaContinue = 'true';
        this.depositService.submitDeposit();
        this.handleGTMEvent('continue');
    }

    unblockForm() {
        // this.behaviorData.changeCVV2('');
        this.store.setAdaInteractionMessage(false);
        this.store.errorCode.set(0);
        this.depositService.resizeCashier();

        let details = this.depositService?.depositInfo?.details || { adjustAmountCount: 1 };
        details.adjustAmountCount = (details.adjustAmountCount || 0) + 1;

        if (this.depositService?.QDType === QDType.GVCBETSLIP) {
            const data = {
                eventName: 'DepositAvailable',
                eventData: {
                    available: true,
                },
            };
            this.depositService.postMessageToParent(data, '*');
        }
        this.depositService.depositInfo.details = details;
        this.handleGTMEvent('cancel');
    }
    handleGTMEvent(eventName: string) {
        this.gtmService.raiseEventForUnusualDeposit(
            eventName,
            'betslip quick deposit',
            this.depositService?.depositInfo?.amountInfo?.nativeAmountString,
        );
    }

    submitPLDeposit() {
        this.depositService.showDepositFailure.set(false);
        this.depositService.resizeCashier();
        this.store.setcontinueDeposit(true);
    }

    depositBack() {
        this.store.setErrorCode(0);
        // this.behaviorData.changeHideInputPage(false);
    }

    gotoWithdrawal() {
        const eventData = {
            component: {
                ...this.tempObj,
                CategoryEvent: 'cashier',
                LabelEvent: 'withdrawal process',
                LocationEvent: 'betslip',
                ActionEvent: 'reverse withdrawal link - clicked',
            },
        };
        this.gtmService.raiseComponentEvent('Event.Tracking', eventData);
        this.optionListService.showWithdrawal = true;
    }

    getSumOfAllReversals() {
        this.reversal.totalAmount = this.reversal.data
            ?.reduce((sum: number, item: any) => sum + parseFloat(item?.redeemAmount?.value || 0), 0)
            .toFixed(2);
    }
    handleArcDepositGtmEvent() {
        const tempObj: { [k: string]: any } = {};
        const eventData = {
            component: {
                ...tempObj,
                CategoryEvent: 'cashier',
                LabelEvent: 'high volume deposit declines - deposit blocked',
                ActionEvent: 'click',
                LocationEvent: 'betslip quick deposit',
                EventDetails: 'high volume deposit declines - blocked message',
                URLClicked: 'not applicable',
            },
        };
        this.gtmService.raiseComponentEvent('Event.Tracking', eventData);
    }
    openKycRedirectUrl() {
        this.navigationService.goTo(this.kycRedirectionUrl, { forceReloadTarget: 'top' });
    }
}
